module.exports = __webpack_public_path__ + "img/about.6abcff8e.png";